import { render } from "./Test2.vue?vue&type=template&id=6abcd29c&scoped=true"
import script from "./Test2.vue?vue&type=script&lang=js"
export * from "./Test2.vue?vue&type=script&lang=js"

import "./Test2.vue?vue&type=style&index=0&id=6abcd29c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abcd29c"]])

export default __exports__